import {Route, Routes} from 'react-router-dom';
import {AllRewardSchemes} from './rewardSchemeTabs/allRewardSchemes';
import {NewRewardScheme} from './rewardSchemeTabs/newRewardScheme';
import {RewardSchemeManagement} from './index';
import {UserReward} from './rewardSchemeTabs/update/tabs/userReward';
import {UpdateRewardSchemeManagement} from './rewardSchemeTabs/update';
import {NewUserRewardScheme} from './rewardSchemeTabs/userRewardGiveout';
import {AllUserReward} from './rewardSchemeTabs/userReward';
import LanguageVersion from './rewardSchemeTabs/update/languageVersion';
import {UserReferral} from 'pages/usersReferral';

const RewardSchemes = () => {
  return (
    <Routes>
      <Route path="/" element={<RewardSchemeManagement />}>
        <Route index path="/" element={<AllRewardSchemes />} />
        <Route path="/users" element={<AllUserReward />} />
        <Route path="/user-referrals" element={<UserReferral />} />
      </Route>
      <Route
        path="/update/:id/:language"
        element={<UpdateRewardSchemeManagement />}>
        <Route index element={<NewRewardScheme />} />
        <Route path="users" element={<UserReward />} />

        <Route />
      </Route>
      <Route path="/new-user-reward" element={<NewUserRewardScheme />} />
      <Route path="/update-user-reward/:id" element={<NewUserRewardScheme />} />

      <Route
        path="/update/language-version/:id"
        element={<LanguageVersion />}
      />
      <Route path="/new" element={<NewRewardScheme />} />
    </Routes>
  );
};

export {RewardSchemes};
